import { Component, PLATFORM_ID, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { generateRandomString } from './core/helpers/generateRandomString.helper';
import { isPlatformBrowser } from '@angular/common';
import { assetsConst } from './core/const/assets.const';
import { AuthService } from './core/services/auth.service';
import { ServiceWorkerRegister } from './core/service-worker/serviceWorker';
import { filter } from 'rxjs/operators';
import {} from 'googlemaps';
import { MatDialog } from "@angular/material/dialog";
import { WelcomePopupComponent } from "./modals/welcome-popup/welcome-popup.component";
import { HomeService } from './core/services/home.service';
import { Title } from '@angular/platform-browser';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let google: any;
declare let gtag: (...args: any[]) => void;

@Component({
  selector: 'megastore-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'megastore';
  assetsConst = assetsConst;
  private platFormId = inject(PLATFORM_ID);
  private welcomePopupOpened = false;
  adsData: any;

  constructor(
    private serviceWorker: ServiceWorkerRegister,
    private _authService: AuthService,
    private router: Router,
    private dialog: MatDialog,
    private _translateService: TranslateService,
    private homeService: HomeService,
    private titleService: Title
  ) {
    this.checkGuestToken();
    _translateService.setDefaultLang('en');
    
    if (isPlatformBrowser(this.platFormId)) {
      // Get the selected language from localStorage or default to 'en'
      const selectedLang = localStorage.getItem(environment.selectedLang) || 'en';
      _translateService.use(selectedLang);
      this._authService.selectedLang.next(selectedLang);
      this.updatePageTitle();
      
      // Subscribe to language changes to update the title dynamically when translations are loaded
      this._translateService.onLangChange.subscribe(() => {
        this.updatePageTitle();
      });
    } else {
      _translateService.use('en');
      this._authService.selectedLang.next('en');
    }
    
    if (isPlatformBrowser(this.platFormId)) {
      const reloadStaus = localStorage.getItem('reloadStatus');
      if (!reloadStaus) localStorage.setItem('reloadStatus', '1');

      // Wait for router navigation to complete before checking location
      this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        this.trackPageView(event.urlAfterRedirects);
        // Don't request location on CMS pages
        if (!event.url.includes('/cms/')) {
          const lat = localStorage.getItem('latitude');
          const lng = localStorage.getItem('longitude');

          if (lat === null && lng === null) {
            this.getCurrentLocation();
          }
        }
          
      });
    }

    this.serviceWorker.publicApi();
    this.getAds();
  }

  getAds() {
    this.homeService.getAds().subscribe((res: any) => {
      this.adsData = res;
      console.log("adsData", this.adsData);
      if (this.adsData.length > 0) {
        this.openWelcomePopup();
      }
    });
  }

  private getCurrentLocation(): void {
    navigator.geolocation.getCurrentPosition(
      position => {
        const { latitude: lat, longitude: lng } = position.coords;
        localStorage.setItem('latitude', JSON.stringify(lat));
        localStorage.setItem('longitude', JSON.stringify(lng));

        // Wait for Google Maps API to be ready before using it
        this.waitForGoogleMaps().then(() => {
          const geocoder = new google.maps.Geocoder();
          const location = { lat,
            lng };

          geocoder.geocode({ location }, (results: { formatted_address: string; }[], status: string) => {
            if (status === 'OK' && results[0]) {
              localStorage.setItem(
                environment.currentAddress,
                results[0].formatted_address
              );
            }
            if (localStorage.getItem(environment.currentAddress)) {
              this._authService.homeReload.next(true);
            }
          });
        });
      },
      error => {
        console.error('Error getting location:', error);
        // Handle error accordingly
      }
    );
  }

  private waitForGoogleMaps(): Promise<void> {
    return new Promise<void>((resolve) => {
      if (typeof google !== 'undefined' && google.maps) {
        resolve();
        return;
      }

      // Poll for Google Maps API availability
      const checkInterval = setInterval(() => {
        if (typeof google !== 'undefined' && google.maps) {
          clearInterval(checkInterval);
          resolve();
        }
      }, 100);

      // Timeout after 10 seconds
      setTimeout(() => {
        clearInterval(checkInterval);
        console.error('Timeout waiting for Google Maps API to load');
        resolve();
      }, 10000);
    });
  }

  private checkGuestToken(): void {
    if (isPlatformBrowser(this.platFormId)) {
      const availableInSession = sessionStorage.getItem(
        environment.guestTokenKey
      );
      const loggedIn = localStorage.getItem(environment.storageKey);

      if (availableInSession === null && loggedIn === null) {
        sessionStorage.setItem(
          environment.guestTokenKey,
          generateRandomString(10)
        );
      }
    }
  }

  private updatePageTitle(): void {
    this._translateService.get('pageTitle').subscribe((title: string) => {
      this.titleService.setTitle(title);
    });
  }

  private trackPageView(url: string): void {
    if (!isPlatformBrowser(this.platFormId) || typeof gtag !== 'function') {
      return;
    }

    gtag('event', 'page_view', {
      page_title: this.titleService.getTitle(),
      page_path: url,
      page_location: window.location.href
    });
  }

  private openWelcomePopup(): void {
    if (isPlatformBrowser(this.platFormId)) {
      const popupClosed = localStorage.getItem("welcomePopupClosed");
      if (!popupClosed && !this.welcomePopupOpened) {
        this.welcomePopupOpened = true;
        const dialogRef = this.dialog.open(WelcomePopupComponent, {
          panelClass: ["modall", "welcome_popup_modal"],
          disableClose: true,
          autoFocus: false,
          maxWidth: "90vw",
          maxHeight: "90vh",
          data: this.adsData
        });

        dialogRef.afterClosed().subscribe(() => {
          this.welcomePopupOpened = false;
        });
      }
    }
  }
}
